import { useEffect, useState, useCallback } from "react";
import {
  Button,
  Typography,
  Stack,
  Box,
  Card,
  CardMedia,
  Grid,
  LinearProgress,
  ListItemText,
  TextField,
  useTheme
} from "@mui/material";
import { IconButton } from "@mui/material";
import {
  GET_USER_ADDRESS,
  GET_USER_STORE_ITEMS,
  SAVE_USER_PURCHASES
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useDispatch } from "react-redux";
import { getMenuCardBuilderBucks } from "../common/GetMenuCardBuilderBucks";
import { setShowalert } from "../../redux/actions/actions";
import LocationMessageModal from "./LocationMessageModal";
import { English } from "../../constant/EnglishFallback";
import { BILightGrey } from "../../assets/helpers";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import defaultRewardsImage from "../../assets/images/default-image-rewards.jpg";

function MyStore() {
  let dispatch = useDispatch();
  const { loginData, menuCardBuilderBucks, multiLanguageData } = useSelector(
    (state) => state?.main
  );
  const userId = loginData?.userInformation?.UserId;
  const [loading, setLoading] = useState(true);
  const [locationVerifyModal, setLocationVerifyModal] = useState(false);
  const [items, setItems] = useState([]);
  const [userCountry, setUserCountry] = useState("");
  const [saveBtnLoadingIndex, setSaveBtnLoadingIndex] = useState(null);

  const LanguageData = multiLanguageData?.RewardStore || {};

  const {
    TEXT_HEADER_SUBTITLE = English.RewardStore.TEXT_HEADER_SUBTITLE,
    TEXT_NO_REWARDS = English.RewardStore.TEXT_NO_REWARDS,
    TEXT_PER_ENTRY = English.RewardStore.TEXT_PER_ENTRY,
    TEXT_BUILDER_BUCKS = English.RewardStore.TEXT_BUILDER_BUCKS,
    TEXT_ENTRIES = English.RewardStore.TEXT_ENTRIES,
    TEXT_QUANTITY = English.RewardStore.TEXT_QUANTITY,
    BUTTON_ENTER_TO_WIN = English.RewardStore.BUTTON_ENTER_TO_WIN,
    TEXT_ENTERED = English.RewardStore.TEXT_ENTERED,
    TEXT_TIMES = English.RewardStore.TEXT_TIMES,
    TEXT_SUCCESS_DIALOG_DESC = English.RewardStore.TEXT_SUCCESS_DIALOG_DESC,
    TEXT_CLOSE_DIALOG_DESCRIPTION = English.RewardStore.TEXT_CLOSE_DIALOG_DESCRIPTION,
    TEXT_VALID_ENTRIES = English.RewardStore.TEXT_VALID_ENTRIES,
    TEXT_NOT_ENOUGH_BUILDERBUCKS = English.RewardStore.TEXT_NOT_ENOUGH_BUILDERBUCKS
  } = LanguageData || {};

  const getLocation = useCallback(async () => {
    const userRewardUrl = `${GET_USER_ADDRESS}/${userId}`;
    try {
      const userAddress = await Getrequestcall(userRewardUrl, loginData?.accessToken);
      if (userAddress?.data) {
        if (userAddress?.data?.data === null) {
          setLocationVerifyModal(true);
        } else {
          const userLocationAddress = userAddress?.data?.data;
          if (userLocationAddress?.latitude == 0 && userLocationAddress?.longitude == 0) {
            setLocationVerifyModal(true);
          } else if (userLocationAddress?.country != "") {
            setUserCountry(userLocationAddress.country);
            await fetchData(userLocationAddress.country);
            setLocationVerifyModal(false);
          } else {
            setLocationVerifyModal(false);
          }
        }
      } else {
        setLocationVerifyModal(true);
      }
    } catch (error) {
      console.error("getLocation-> Error fetching location: ", error);
    } finally {
      setLoading(false);
    }
  }, [userId, loginData?.accessToken]);

  const normalizeCountry = (country) => {
    const normalizedCountry = country?.trim()?.toLowerCase();

    const countryMap = {
      "united states": "usa",
      "usa": "usa",
      "us": "usa",
      "america": "usa",
      "united kingdom": "uk",
      "uk": "uk",
      "great britain": "uk",
      "britain": "uk",
      "england": "uk"
    };

    return countryMap[normalizedCountry] || normalizedCountry || "";
  };

  const fetchData = useCallback(
    async (userCountry) => {
      const normalizedUserCountry = normalizeCountry(userCountry);

      try {
        const storeItemsResponse = await Getrequestcall(
          `${GET_USER_STORE_ITEMS}/${userId}`,
          loginData?.accessToken
        );
        const filteredItems =
          storeItemsResponse?.data?.data
            .filter(
              (item) =>
                item.recordStatus !== "Not Visible" &&
                item.recordStatus !== "New" &&
                normalizeCountry(item.country) === normalizedUserCountry
            )
            .map((item) => ({ ...item, quantity: 1 })) || [];
        setItems(filteredItems);
      } catch (error) {
        console.error("fetchData-> Error fetching data: ", error);
      }
    },
    [userId, loginData?.accessToken]
  );

  // Enhanced quantity validation function
  const validateQuantity = (value, maxAllowed) => {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue < 1) return 1;
    if (numValue > maxAllowed) return maxAllowed;
    return numValue;
  };

  // Handle direct quantity input change
  const onQuantityInputChange = (index, value) => {
    let duplicateItems = [...items];
    const currentItem = duplicateItems[index];
    const maxAllowed = currentItem.totalEntries - currentItem.nrOfItems;

    // Allow empty input for better user experience while typing
    if (value === "") {
      duplicateItems[index].quantity = "";
      setItems(duplicateItems);
      return;
    }

    // Validate and set quantity
    const validatedQuantity = validateQuantity(value, maxAllowed);
    duplicateItems[index].quantity = validatedQuantity;
    setItems(duplicateItems);
  };

  // Handle quantity input blur (when user leaves the field)
  const onQuantityInputBlur = (index) => {
    let duplicateItems = [...items];
    const currentItem = duplicateItems[index];
    const maxAllowed = currentItem.totalEntries - currentItem.nrOfItems;

    // If empty or invalid, set to 1
    if (duplicateItems[index].quantity === "" || duplicateItems[index].quantity < 1) {
      duplicateItems[index].quantity = 1;
      setItems(duplicateItems);
    }
  };

  const onPlusQuantityClicked = (i) => {
    let duplicateItems = [...items];
    const currentItem = duplicateItems[i];
    const maxAllowed = currentItem.totalEntries - currentItem.nrOfItems;
    const currentQuantity = parseInt(currentItem.quantity) || 1;

    if (currentQuantity < maxAllowed) {
      duplicateItems[i].quantity = currentQuantity + 1;
      setItems(duplicateItems);
    }
  };

  const onMinusQuantityClicked = (i) => {
    let duplicateItems = [...items];
    const currentQuantity = parseInt(duplicateItems[i].quantity) || 1;

    if (currentQuantity > 1) {
      duplicateItems[i].quantity = currentQuantity - 1;
      setItems(duplicateItems);
    }
  };

  const getUpdatedCount = async () => {
    dispatch(getMenuCardBuilderBucks(userId, loginData?.accessToken));
  };

  const handleActionClick = async (item, index) => {
    const quantity = parseInt(item.quantity) || 1;

    if (quantity === 0 || isNaN(quantity)) {
      dispatch(setShowalert({ showAlert: true, text: TEXT_VALID_ENTRIES }));
      return;
    }

    if (quantity * item.entryPrice > menuCardBuilderBucks?.bucks) {
      dispatch(setShowalert({ showAlert: true, text: TEXT_CLOSE_DIALOG_DESCRIPTION }));
      return;
    }

    try {
      setSaveBtnLoadingIndex(index);
      const purchaseData = {
        UserId: Number(userId),
        ReturnRecordId: false,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            UserId: Number(userId),
            StoreItemId: item.id,
            ItemId: item.itemId,
            Qty: quantity,
            StatusId: 4,
            Price: item.entryPrice,
            ModifiedBy: Number(userId)
          }
        ]
      };

      await Postrequestcall(SAVE_USER_PURCHASES, purchaseData, loginData?.accessToken);

      dispatch(setShowalert({ showAlert: true, text: TEXT_SUCCESS_DIALOG_DESC }));
      await getUpdatedCount();
      setItems((prevItems) => {
        const updatedItems = [...prevItems];
        updatedItems[index].quantity = 1;
        return updatedItems;
      });
      await fetchData(userCountry);
    } catch (error) {
      console.error("handleActionClick-> Error during purchase: ", error);
    } finally {
      setSaveBtnLoadingIndex(null);
    }
  };

  useEffect(() => {
    getLocation();
  }, [getLocation]);

  const RewardCard = (item, index) => {
    const currentQuantity = parseInt(item.quantity) || 1;
    const maxAllowed = item.totalEntries - item.nrOfItems;
    const theme = useTheme();

    return (
      <Card
        key={index.toString()}
        className="pagelist-content"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          borderRadius: 3,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
        }}
      >
        <CardMedia
          component="img"
          image={item?.fileUrl || defaultRewardsImage}
          alt={item?.itemName}
          sx={{
            width: "100%",
            aspectRatio: "16/9",  // Maintains 16:9 ratio
            objectFit: "cover",
            objectPosition: "center",
            maxHeight: {
              xs: "200px",
              sm: "300px",
              md: "400px"
            }
          }}
        />


        <Box sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
          {/* Title + Entry Price */}
          <Stack spacing={0.5}>
            <Typography
              variant="h6"
              noWrap
              sx={{ fontWeight: 600, color: theme.palette.text.primary }}
            >
              {item?.itemName}
            </Typography>

            {item.actionType === "Redeem" ? (
              <Typography variant="body2"  sx={{color: "primary",  fontWeight: 500 }}>
                {item.entryPrice} {TEXT_BUILDER_BUCKS}
              </Typography>
            ) : (
              <Stack direction="row" sx={{ alignItems: "center" }} spacing={0.5}>
                <Typography variant="body2"  sx={{color: "primary",  fontWeight: 600 }}>
                  {item.entryPrice} {TEXT_BUILDER_BUCKS}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {TEXT_PER_ENTRY}
                </Typography>
              </Stack>
            )}
          </Stack>

          {/* Progress Bar */}
          <LinearProgress
            variant="determinate"
            value={item?.itemProgress}
            sx={{
              height: 6,
              borderRadius: 5,
              backgroundColor: theme.palette.grey[200],
            }}
          />

          {/* Entries Info */}
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
            {item?.nrOfUserItems > 0 && (
              <Typography
                variant="body2"
                sx={{
                  backgroundColor: BILightGrey,
                  borderRadius: "4px",
                  px: 1,
                  py: 0.2,
                  fontWeight: 500,
                }}
              >
                {TEXT_ENTERED} {item?.nrOfUserItems} {TEXT_TIMES}
              </Typography>
            )}
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {item?.nrOfItems}/{item?.totalEntries} {TEXT_ENTRIES}
            </Typography>
          </Stack>

          {/* Quantity + Button Section */}
          {!(item.nrOfItems === item.totalEntries || currentQuantity + item.nrOfItems > item.totalEntries) && (
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={{ xs: 2, md: 3 }}
              sx={{
                mt: 1.5,
                alignItems: { xs: "center", md: "flex-end" },
                justifyContent: { xs: "center", md: "space-between" },
                width: "100%",
              }}
            >
              {/* Quantity Controls */}
              <Stack sx={{ alignItems: "center", justifyContent: "center", width: "100%" }} flex={1}>
                <Typography variant="body2" sx={{ mb: 0.5,  color: "text.secondary" }} >
                  {TEXT_QUANTITY}
                </Typography>

                <Stack sx={{ alignItems: "center", justifyContent: "center" }} direction="row" spacing={1.5}>
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: BILightGrey,
                      "&:hover": { backgroundColor: (theme) => theme.palette.grey[300] },
                    }}
                    onClick={() => onMinusQuantityClicked(index)}
                    disabled={currentQuantity <= 1}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>

                  <TextField
                    type="number"
                    value={item.quantity}
                    onChange={(e) => onQuantityInputChange(index, e.target.value)}
                    onBlur={() => onQuantityInputBlur(index)}
                    inputProps={{
                      min: 1,
                      max: maxAllowed,
                      step: 1,
                      style: {
                        textAlign: "center",
                        padding: "6px 4px",
                        fontSize: "14px",
                      },
                    }}
                    sx={{
                      width: "70px",
                      "& .MuiOutlinedInput-root": {
                        height: 36,
                        borderRadius: 2,
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                        display: "none",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                    }}
                  />

                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: BILightGrey,
                      "&:hover": { backgroundColor: (theme) => theme.palette.grey[300] },
                    }}
                    onClick={() => onPlusQuantityClicked(index)}
                    disabled={currentQuantity >= maxAllowed}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </Stack>

              {/* Action Button */}
              <Button
                loading={saveBtnLoadingIndex === index}
                variant="contained"
                fullWidth
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  fontWeight: "bold",
                  minHeight: { xs: 44, md: 48 },
                  width: { xs: "100%", md: "50%" },
                  alignSelf: { xs: "center", md: "flex-end" },
                  backgroundColor: (theme) => theme.palette.primary.main,
                  "&:hover": {
                    backgroundColor: (theme) => theme.palette.primary.dark,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: (theme) => theme.palette.grey[300],
                    color: (theme) => theme.palette.text.disabled,
                    opacity: 1, // prevent MUI from dimming it too much
                    cursor: "not-allowed",
                  },
                }}
                onClick={() => handleActionClick(item, index)}
                disabled={
                  item.entryPrice * currentQuantity > menuCardBuilderBucks?.bucks ||
                  item.nrOfItems === item.totalEntries ||
                  currentQuantity + item.nrOfItems > item.totalEntries ||
                  currentQuantity === 0 ||
                  isNaN(currentQuantity)
                }
              >
                <Stack>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {BUTTON_ENTER_TO_WIN}
                  </Typography>
                  <Typography variant="body2" >
                    {item.entryPrice * currentQuantity > menuCardBuilderBucks?.bucks ||
                      currentQuantity + item.nrOfItems > item.totalEntries
                      ? TEXT_NOT_ENOUGH_BUILDERBUCKS
                      : `${item.entryPrice * currentQuantity} ${TEXT_BUILDER_BUCKS}`}
                  </Typography>
                </Stack>
              </Button>

            </Stack>

          )}
        </Box>
      </Card>
    );
  };

  return (
    <Box className="main-content-card-list">
      {loading ? (
        <Loader />
      ) : (
        <>
          {locationVerifyModal === true ? (
            <LocationMessageModal open={locationVerifyModal} />
          ) : (
            <>
              <Typography sx={{ textAlign: "center", color: "text.secondary",  p: 2, pt: 1 }} variant="body1">
                {TEXT_HEADER_SUBTITLE}
              </Typography>
              {items?.length > 0 ? (
                <Grid container spacing={{ xs: 1.5, md: 2 }}>
                  {items?.map((item, index) => (
                    <Grid key={index} size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }}>
                      {RewardCard(item, index)}
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography variant="body1"  sx={{color: "error",  textAlign: "center" }}>
                  {TEXT_NO_REWARDS}
                </Typography>
              )}
            </>
          )}
        </>
      )}
    </Box>
  );
}

export default MyStore;
